import { styled } from '@mui/material/styles';

import { THEME } from '../../constants/Constants';
import colors from '../../theming/tokens/colors';

const display = {
  [THEME.DENTOLO_LEFT_ALIGN_THEME]: 'flex',
  DEFAULT: 'block',
};

const backgroundColor = {
  [THEME.DENTOLO_LEFT_ALIGN_THEME]: colors.WHITE,
  DEFAULT: 'transparent',
};

const borderRadius = {
  [THEME.DENTOLO_LEFT_ALIGN_THEME]: '8px',
  DEFAULT: 0,
};

const tabletWidth = {
  [THEME.DENTOLO_LEFT_ALIGN_THEME]: '38rem',
  DEFAULT: '100%',
};

const desktopWidth = {
  [THEME.DENTOLO_LEFT_ALIGN_THEME]: '54rem',
  DEFAULT: '100%',
};

/* eslint-disable import/prefer-default-export */
export const StyledPageOuterContainer = styled('main')(({ theme }) => ({
  display: display[theme?.name] || display.DEFAULT,
  margin: '0 auto',
  width: '100%',
  backgroundColor: backgroundColor[theme?.name] || backgroundColor.DEFAULT,
  boxShadow: 'none',
  borderRadius: borderRadius[theme?.name] || borderRadius.DEFAULT,

  [theme.breakpoints.up('mobile')]: {
    margin: 0,
    width: tabletWidth[theme?.name] || tabletWidth.DEFAULT,
  },

  [theme.breakpoints.up('desktop')]: {
    width: desktopWidth[theme?.name] || desktopWidth.DEFAULT,
  },
}));
/* eslint-enable import/prefer-default-export */
